import {
  Component,
  Input,
  OnChanges,
  Renderer2,
  OnInit,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
  AfterViewChecked,
} from "@angular/core";
import { CoreService } from "src/app/shared/services/core.service";
import { Merchant } from "../../models/merchant";
import { Location, NgStyle, AsyncPipe, DecimalPipe } from "@angular/common";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app.state";
import { GetCategories } from "src/app/store/actions/category.actions";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HomeComponent } from "../../../home/home/home.component";
import { PopupLoginOptionsComponent } from "src/app/auth/popup-login-options/popup-login-options.component";
import { GetMerchant } from "src/app/store/actions/merchant.actions";
import { Router } from "@angular/router";
import { CurrencyFormatPipe } from "../pipe/status.pipe";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  standalone: true,
  imports: [NgStyle, AsyncPipe, DecimalPipe,CurrencyFormatPipe, PopupLoginOptionsComponent],
})
// Component to display the footer
export class FooterComponent implements OnChanges, AfterViewChecked {
  @Input() Home; // Input property to determine if it's the Home page
  @Input() RouetChangeDetect;
  @Input() Merchant: Merchant; // Input property to store Merchant data
  IsLoginEnable: boolean = false; // Variable to control footer visibility
  IsMultiLoginEnable: boolean = false; // Variable to control footer visibility
  currentBasket = this.coreService.currentBasket;
  basket$ = this.coreService.basket$;
  basketCount;
  IsMultiOutlet;
  IsSingleOutletHome;
  ShowLoginOption;
  FromMultiOutlet;
  FromSingleOutlet;
  selectedLanguage: string = "";
  // selectedLanguageFlag: string = "🌐";
   selectedLanguageFlag: string = "🇬🇧";
  
  languageFlags: Record<string, string> = {
  ar: "🇸🇦",
  km: "🇰🇭",
  nl: "🇳🇱",
  en: "🇬🇧",
  fr: "🇫🇷",
  de: "🇩🇪",
  el: "🇬🇷",
  hi: "🇮🇳",
  id: "🇮🇩",
  it: "🇮🇹",
  lo: "🇱🇦",
  ms: "🇲🇾",
  pt: "🇵🇹",
  ru: "🇷🇺",
  es: "🇪🇸",
  th: "🇹🇭",
  vi: "🇻🇳",
};

  @ViewChild("selectControl") selectControl: ElementRef;
  constructor(
    public coreService: CoreService,
    private _location: Location,
    private _store: Store<IAppState>,
    private modalService: NgbModal,
    private router: Router,
  ) {
    // Constructor to inject CoreService and Location dependencies
  }
  ngAfterViewChecked(): void {
    const googtransCookie = this.getCookie("googtrans");
    // if (googtransCookie && this.selectControl) {
    //   this.selectControl.nativeElement.value = googtransCookie;
    // }
     if (googtransCookie) {
    this.selectedLanguage = googtransCookie;

    this.selectedLanguageFlag =
      this.languageFlags[googtransCookie] || "🌐";

    if (this.selectControl) {
      this.selectControl.nativeElement.value = googtransCookie;
    }
  }

    if (this.Merchant?.webapp_settings?.is_login_registration_allowed) {
      // If login and registration are allowed, check user authentication status
      this.IsLoginEnable = this.IsUserAuthunticated();
      this.IsMultiLoginEnable = this.IsMultiUserAuthunticated();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Lifecycle hook to handle input property changes

    // Check if the app has multi-outlet functionality
    if (CoreService.MultiOutlet) {
      this.IsMultiOutlet = true;

      // If the app has multi-outlet, determine whether the current route is the homepage
      if (this.coreService.stcurrentUrl == "/") {
        this.Home = true; // Set Home to true if the current URL is the homepage
        this.IsSingleOutletHome = false;
      } else if (this.coreService.stcurrentUrl.includes("dashboard")) {
        this.Home = false; // Otherwise, set Home to false
        this.IsSingleOutletHome = true;
      } else {
        this.Home = false; // Otherwise, set Home to false
        this.IsSingleOutletHome = false;
        // this.IsMultiOutlet = false;
      }

      this.IsMultiLoginEnable = this.IsMultiUserAuthunticated();
    }

    // Un-Comment this
    if (this.coreService.stcurrentUrl.includes("/products")) {
      this.Home = false;
    } else if (this.coreService.stcurrentUrl.includes("/about")) {
      this.Home = false;
    } else if (this.coreService.stcurrentUrl.includes("/category")) {
      this.Home = false;
    }

    // Check if login and registration are allowed based on the Merchant's webapp_settings
    // if (this.Merchant?.webapp_settings?.is_login_registration_allowed) {
    //   // If login and registration are allowed, check user authentication status
    // }
    this.IsLoginEnable = this.IsUserAuthunticated();
  }

  ngOnInit() {
    const savedLanguage = localStorage.getItem("googtrans");

  if (savedLanguage && this.languageFlags[savedLanguage]) {
    this.selectedLanguage = savedLanguage;
    this.selectedLanguageFlag = this.languageFlags[savedLanguage];
    }
    
    // Lifecycle hook called after component initialization, but not used in this component
    this.basket$.subscribe((data) => {
      this.currentBasket = data; // Update the current basket with the received data
      this.basketCount = this.currentBasket?.items
        ?.filter((x) => x.productId == null || x.productId == "")
        .reduce((sum, item) => sum + item.quantity, 0);
    });
    // Check if login and registration are allowed based on the Merchant's webapp_settings
    // if (this.Merchant.webapp_settings?.is_login_registration_allowed) {
    //   // If login and registration are allowed, check user authentication status
    // }
    this.IsLoginEnable = this.IsUserAuthunticated();

    if (CoreService.MultiOutlet) {
      this.IsMultiOutlet = true;
      this.IsMultiLoginEnable = this.IsMultiUserAuthunticated();
    } else {
      this.IsMultiOutlet = false;
    }
  }

  // Function to display the selected Retailer information in a popup
  StoreInfo(content) {
    // Store the RetailerName and RetailerDesc in the pageModel for display in the popup
    // this.pageModel.RetailerName = RetailerName;
    // this.pageModel.RetailerDesc = RetailerDesc;

    if (CoreService.MultiOutlet && this.basketCount > 0) {
      // Open the modal popup with the given content, centered, scrollable, and static backdrop
      this.modalService.open(content, {
        centered: true,
        scrollable: true,
        backdrop: "static",
      });
    } else {
      this.GoToHome();
    }
  }

  GoBack() {
    // Method to navigate back to the previous page or homepage based on app settings
    if (
      CoreService.MultiOutlet &&
      (this.coreService.stcurrentUrl == "/" ||
        this.coreService.stcurrentUrl.includes("/dashboard") ||
        this.coreService.stcurrentUrl.includes("/login") ||
        this.coreService.stcurrentUrl.includes("/receipt"))
    ) {
      // Check if the app has multi-outlet and if the current URL is one of the specified pages

      // Navigate to the homepage
      this.coreService.navigateTo("/");
    } else if (this.coreService.stcurrentUrl.includes("/receipt")) {
      // Check if the current URL includes "/receipt"

      // Navigate to the dashboard page
      this.coreService.navigateTo("/dashboard");
    } else {
      // If not on any of the specified pages, handle navigation based on login and authentication status

      if (
        this.Merchant.webapp_settings?.is_login_registration_allowed &&
        !this.IsUserAuthunticated()
      ) {
        // If login and registration are allowed and user is not authenticated

        // Navigate to the login page
        //this.coreService.navigateTo("/login");
        this._location.back();
      } else {
        // Otherwise, navigate back to the previous page using the Location service
        this._location.back();
      }
    }
  }

  GoToHome() {
    sessionStorage.removeItem("isPermotion");
    const cooldownInterval =
      this.Merchant?.welcome_notification_cooldown_interval ?? 0; // default 0 mins

    const ignoreNotificationId = CoreService.MultiOutlet
      ? this.getIgnoreNotificationIdsForHome(cooldownInterval)
      : "";
    this._store.dispatch(
      new GetMerchant(
        this.coreService.getmerchantReqData("", "", ignoreNotificationId),
      ),
    );

    // Method to navigate to the homepage or dashboard based on app settings
    if (!CoreService.MultiOutlet) {
      // Check if the app does not have multi-outlet functionality

      if (
        this.Merchant.webapp_settings?.is_login_registration_allowed &&
        !this.IsUserAuthunticated()
      ) {
        // If login and registration are allowed and user is not authenticated
        // Navigate to the login page
        // this.coreService.navigateTo("/login");
        this.coreService.navigateTo("/dashboard");
      } else {
        // Navigate to the dashboard page
        this.coreService.navigateTo("/dashboard");
      }

      this._store.dispatch(new GetCategories(""));
      this.modalService.dismissAll();
    } else {
      // If the app has multi-outlet functionality

      if (
        this.coreService.stcurrentUrl !== "/" &&
        this.Merchant.webapp_settings?.is_login_registration_allowed &&
        !this.IsUserAuthunticated()
      ) {
        // If not on the homepage, login is allowed, and user is not authenticated

        // Navigate to the login page
        // this.coreService.navigateTo("/login");
        this.coreService.navigateTo("/dashboard");
      }

      // Navigate to the homepage
      this.coreService.navigateTo("/");

      this.coreService.clearBasket(false);

      this.modalService.dismissAll();
    }
  }



  GoToOutletHome() {
    this.coreService.navigateTo("/dashboard");
  }

  Logout() {
    // Method to handle user logout

    // Remove user data from local storage
    localStorage.removeItem("currentUser");

    // Notify subscribers that user data has been cleared
    this.coreService.UserSub.next(null);

    // Clear the shopping basket
    this.coreService.clearBasket(false);

    // Navigate to the Login page
    // this.coreService.navigateTo("/login");
    if (CoreService.MultiOutlet) {
      this.coreService.navigateTo("/");
    } else {
      this.coreService.navigateTo("/dashboard");
    }

    this.IsLoginEnable = false;
    this.IsMultiLoginEnable = false;
  }

  VisitProfile() {
    // Method to handle user logout
    // Temporary navigation to receipt page
    // this.coreService.navigateTo("/receipt");

    if (CoreService.MultiOutlet) {
      if (this.IsMultiUserAuthunticated()) {
        this.coreService.navigateTo("/profile");
      } else {
        this.ShowLoginOption = true;
        this.FromMultiOutlet = true;
        this.FromSingleOutlet = false;
      }
    } else {
      if (this.IsLoginEnable) {
        this.coreService.navigateTo("/profile");
      } else {
        this.ShowLoginOption = true;
        this.FromMultiOutlet = false;
        this.FromSingleOutlet = true;
      }
    }
  }

  IsUserAuthunticated() {
    // Method to check if the user is authenticated

    // Check if user data exists in local storage and the current URL is not the homepage,
    // and guest access is not allowed and a valid token is present
    if (
      localStorage.getItem("currentUser") &&
      this.coreService.stcurrentUrl !== "/" &&
      !JSON.parse(localStorage.getItem("currentUser") || "{}")
        .guest_access_allowed &&
      JSON.parse(localStorage.getItem("currentUser") || "{}").token
    ) {
      return true; // User is authenticated
    } else {
      return false; // User is not authenticated
    }
  }

  IsMultiUserAuthunticated() {
    // Method to check if the user is authenticated

    // Check if user data exists in local storage and the current URL is not the homepage,
    // and guest access is not allowed and a valid token is present
    if (
      localStorage.getItem("currentUser") &&
      // this.coreService.stcurrentUrl !== "/" &&
      !JSON.parse(localStorage.getItem("currentUser") || "{}")
        .guest_access_allowed &&
      JSON.parse(localStorage.getItem("currentUser") || "{}").token
    ) {
      return true; // User is authenticated
    } else {
      return false; // User is not authenticated
    }
  }

  OpenBasket() {
    if (this.currentBasket != null && this.currentBasket.items.length > 0) {
      this.coreService.navigateTo("/basket"); // Navigate to the basket page
    }
  }

  onSelectChange(value) {
     this.selectedLanguage = value;

  this.selectedLanguageFlag =
    this.languageFlags[value] || "🌐";
    this.setCookie("googtrans", "/en/" + value, 24);
    localStorage.setItem("googtrans", value);
    window.location.reload();
  }

  // Function to get cookie value
  getCookie(name: string): string | null {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      cookie = cookie.trim();
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
        const decodedValue = decodeURIComponent(cookieValue);
        return decodedValue.replace("/en/", "");
      }
    }
    return null;
  }

  setCookie(key: string, value: string, expiry: number) {
    const expires = new Date();
    expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
    // Remove existing cookie with the same name
    this.deleteAllGoogtransCookies();
    // Set the new cookie
    document.cookie = `${key}=${value}`;
  }

  deleteAllGoogtransCookies() {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookieParts = cookies[i].split("=");
      const name = cookieParts[0].trim();
      if (name === "googtrans") {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.toodleweb.app;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=${window.location.hostname};path=/`;
      }
    }
  }

  closeOptionPopup() {
    this.ShowLoginOption = false;
  }

  isIosSafari(): boolean {
    const ua = window.navigator.userAgent;

    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(
      ua,
    );

    return isIOS && isSafari;
  }

  getIgnoreNotificationIdsForHome(cooldownMinutes: number): string {
    let latestNotificationId = "";
    let latestTimestamp = 0;

    // Get all sessionStorage keys that match the pattern
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith("HOME_POPUP_TIMESTAMP_")) {
        const bannerId = key.replace("HOME_POPUP_TIMESTAMP_", "");
        const storedTimestamp = sessionStorage.getItem(key);

        if (storedTimestamp) {
          const storedTime = parseInt(storedTimestamp, 10);
          const currentTime = Date.now();
          const diffMinutes = (currentTime - storedTime) / 60000;

          // If still within cooldown period, consider it
          if (diffMinutes < cooldownMinutes) {
            // Find the most recently shown notification
            if (storedTime > latestTimestamp) {
              latestTimestamp = storedTime;
              latestNotificationId = bannerId;
            }
          } else {
            // Remove expired entries
            sessionStorage.removeItem(key);
          }
        }
      }
    }

    return latestNotificationId;
  }

  onInstallClick(content: any) {
    if (this.isIosSafari()) {
      this.modalService.open(content, {
        centered: true,
        backdrop: "static",
      });
      return;
    }

    this.coreService.installPWA();
  }

  // get showInstallButton(): boolean {
  //   const url = this.router.url;

  //   console.log("Current URL:", url);
  //   console.log("Is Home (/):", url === "/");
  //   console.log("Starts with /dashboard:", url.startsWith("/dashboard"));

  //   const show = url === "/" || url.startsWith("/dashboard");

  //   console.log("Final showInstallButton:", show);

  //   return show;
  // }

  get showInstallButton(): boolean {
    const url = this.router.url.split("?")[0];

    const show = url === "/" || url.startsWith("/dashboard");

    // console.log("Original URL:", this.router.url);
    // console.log("Clean URL:", url);
    // console.log("Is Home (/):", url === "/");
    // console.log("Starts with /dashboard:", url.startsWith("/dashboard"));
    // console.log("Final showInstallButton:", show);

    return show;
  }
}
